import * as types from '@/store/mutationTypes';

export const mutations = {
    [types.SET_SHOPPING_CART](state, shoppingCart) {
        state.shoppingCart = shoppingCart;
    },

    [types.SET_SHOPPING_INDICATOR](state, shoppingIndicator) {
        state.shoppingIndicator = shoppingIndicator;
    },

    [types.SET_EXIST_CARD](state, existCard) {
        state.existCard = existCard;
    },

    [types.SET_PAYMENT](state, paid) {
        state.isPaid = paid;
    },

    [types.SET_COUPON_CODE](state, couponCode) {
        state.couponCode = couponCode;
    },

    [types.TOGGLE_FREE_ACTIVITY](state, freeActivity) {
        state.freeActivity = freeActivity;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/shoppingCart/mutations.js